module.exports = __webpack_public_path__ + "static/true-blackboard-51aef711ae428395b2aec124fde32f50.jpg";